"use client";

import React, { useEffect, useState } from "react";
import "./style.css";
import { colors } from "@mui/joy";
import { fetchAPI } from "../../utils/api";
import Link from "next/link";

const Typemem = () => {
  const [memberTypes, setMemberTypes] = useState([]);

  useEffect(() => {
    fetchAPI("/SignUpPackageType_V2?SystemID=55")
      .then((res) => {
        if (res?.Data?.length > 0) {
          setMemberTypes(res.Data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <section className="section-bg">
      <div id="membership-anchor" className="join-cont">
        <h2 style={{ paddingBottom: "70px" }}>JOIN FLP TODAY!</h2>

        <div className="option-flex-container">
          <div id="mobile-blue-container" className="item1">
            <div className="package-card">
              <div className="package-card-child">
                <img
                  style={{ left: "-38px" }}
                  className="package-card-img"
                  src="https://nouf-flp-images.s3.af-south-1.amazonaws.com/flp-standard+with+shape+(1).png"
                />
                <div className="package-card-text" style={{ display: "flex" }}>
                  <div className="bg-opacity">
                    <div className="select-membership-hover">
                      R250 Once Off <br /> R195 Per Month
                    </div>
                    <br />
                    <div className="green-or">OR</div>
                    <br />
                    <div>R2,145 Per Annum</div>
                  </div>
                  <br />

                  <div>
                    <div className="top-space">
                      <h4>BENEFITS</h4>
                      Flight & Car Hire
                      <br />
                      Tours & Activities
                      <br />
                      Dining
                      <br />
                      Deals-4-u
                      <br />
                      Holidays
                      <br />
                      Cruises
                      <br />
                      Movies
                      <br />
                      Spas
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div style={{ background: "#d4232b" }} className="item2">
            <div className="package-card">
              <div
                style={{ background: "#d4232b" }}
                className="package-card-child"
              >
                <img
                  style={{ left: "-38px" }}
                  className="package-card-img"
                  src="https://nouf-flp-images.s3.af-south-1.amazonaws.com/flp-connect+with+shape.png"
                />
                <div className="package-card-text" style={{ display: "flex" }}>
                  <div>
                    <div className="bg-opacity">
                      <div>
                        R250 Once Off <br /> R249 Per Month
                      </div>
                      <br />
                      <div className="green-or">OR</div>
                      <br />
                      <div>R2,739 Per Annum</div>
                    </div>
                    <br />
                    <br />
                    <div
                      className="package-card-pill"
                      style={{
                        background: "white",
                        boxShadow: "none",
                        position: "relative",
                      }}
                    >
                      <img
                        className="premium-pill"
                        src="https://nouf-flp-images.s3.af-south-1.amazonaws.com/flp_connect_plus_bg.png"
                        alt=""
                      />
                      <span className="premium-pill-text">PLUS</span>
                      <span style={{ color: "red", fontWeight: "bold" }}>
                        R249 Back in <br /> airtime every month
                      </span>
                    </div>

                    <img
                      style={{
                        top: "-211px",
                        left: "69px",
                        width: "150px",
                        height: "40px",
                      }}
                      className="premium-pill top"
                      src="https://nouf-flp-images.s3.af-south-1.amazonaws.com/Layer+1+copy+2.png"
                      alt=""
                    />
                    <span
                      style={{ top: "-200px", left: "105px" }}
                      className="premium-pill-text topplus"
                    >
                      Go Premium
                    </span>

                    <br />
                  </div>
                  <div>
                    <h4>BENEFITS</h4>
                    Flight & Car Hire
                    <br />
                    Tours & Activities
                    <br />
                    Dining
                    <br />
                    Deals-4-u
                    <br />
                    Holidays
                    <br />
                    Cruises
                    <br />
                    Movies
                    <br />
                    Spas
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="membership-join-btn">
          <a href="/join-now">
            <div style={{ marginTop: "14px" }} className="package-card-pill">
              JOIN NOW
            </div>
          </a>
        </div>

        <div className="cal-desk-cont">
          <div className="cal-desk">
            <div style={{ position: "relative", flex: "1" }}>
              <img
                className="premium-pill"
                src="https://nouf-flp-images.s3.af-south-1.amazonaws.com/Layer+1+copy+2.png"
                alt=""
              />
              <span className="premium-pill-text">Go premium</span>
              <img
                className="white-shape"
                src="https://nouf-flp-images.s3.af-south-1.amazonaws.com/oddshp.png"
              />
              <div className="ex-inner-text-2">
                <span style={{ color: "#d4232b" }}>
                  ARE YOU AN EXISTING
                  <br />
                  FLP MEMBER?{" "}
                </span>{" "}
                <br /> <span className="upgrade-today">UPGRADE TODAY</span>
              </div>
            </div>
            <div style={{ flex: "1" }}>
              <div className="red-bg">
                <h4>Upgrade to FLP Connect and skip the joining fees.</h4>
                Enjoy the same brilliant FLP Standard benefits PLUS get R249
                back in airtime every month.
                <br />
                <br />
                Upgrade from FLP Standard to FLP Connect for R249pm and you will
                be FLP Connect-ed to living your best life!
              </div>
            </div>
          </div>
          <Link href={"/account"}>
            <button className="upgrade-but2">
              UPGRADE <br /> NOW
            </button>
          </Link>
        </div>

        <div
          style={{
            background: "transparent",
            justifyContent: "center",
          }}
          className="item2 alreadymember"
          id="memberal"
        >
          <div className="package-card-parent">
            <div className="package-card">
              <div className="ex-inner-text-2">
                <span style={{ color: "#d4232b" }}>
                  ARE YOU AN EXISTING
                  <br />
                  FLP MEMBER?{" "}
                </span>{" "}
                <br /> <span className="upgrade-today">UPGRADE TODAY</span>
              </div>
              <div
                style={{ background: "#d4232b" }}
                className="package-card-child"
              >
                <img
                  className="package-card-img"
                  src="https://nouf-flp-images.s3.af-south-1.amazonaws.com/oddshp.png"
                />
                <div className="package-card-text" style={{ display: "flex" }}>
                  <div>
                    <img
                      className="premium-pill"
                      src="https://nouf-flp-images.s3.af-south-1.amazonaws.com/Layer+1+copy+2.png"
                      alt=""
                    />
                    <span className="premium-pill-text">Go premium</span>

                    <br />
                  </div>
                  <div style={{ padding: "30px" }}>
                    <h4>Upgrade to FLP Connect and skip the joining fees.</h4>
                    Enjoy the same brilliant FLP Standard benefits PLUS get R249
                    back in airtime every month.
                    <br />
                    Upgrade from FLP Standard to FLP Connect for R249pm and you
                    will be FLP Connect-ed to living your best life!
                  </div>
                  {/*                   {typeof window !== "undefined" &&
                    window.localStorage.getItem("flp-token") ? (
                      <a
                        onClick={(e) => {
                          e.preventDefault();
          
                          router.push("/account");
                        }}
                      >
                       <button className="upgrade-but2">
                          UPGRADE <br /> NOW
                        </button>
                      </a>
                    ) : (
                      <a onClick={openLoginModal}>
                        <button className="upgrade-but2">
                          UPGRADE <br /> NOW
                        </button>
                      </a>
                    )} */}
                  <Link href={"/account"}>
                    <button className="upgrade-but2">
                      UPGRADE <br /> NOW
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Typemem;
